import { Link } from 'react-router-dom';
import { CaretRight, House } from '@phosphor-icons/react';

export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="flex items-center gap-1.5 text-sm mb-4">
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <span key={item.path || `breadcrumb-${idx}`} className="flex items-center gap-1.5">
            {idx > 0 && <CaretRight size={12} className="text-navy-300" />}
            {isLast ? (
              <span className="font-semibold text-navy-900 truncate max-w-[200px]" data-testid={`breadcrumb-current`}>
                {item.label}
              </span>
            ) : (
              <Link
                to={item.path}
                className="text-navy-500 hover:text-orange-600 transition-colors"
                data-testid={`breadcrumb-${idx}`}
              >
                {idx === 0 && item.icon ? (
                  <span className="flex items-center gap-1">
                    {item.icon}
                    {item.label}
                  </span>
                ) : (
                  item.label
                )}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
